import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProposalService } from '../services/proposal.service';
import { ProjectService } from '../services/project.service';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from '../services/modal.service';
import { getStoredUser } from '../helpers/user-storage.util';
import { RequirementsAcknowledgementComponent } from '../requirements-acknowledgement/requirements-acknowledgement.component';
import { projectHasSiteRequirements } from '../utils/site-requirements';
@Component({
  selector: 'allbids-dialog',
  standalone: true,
  imports: [CommonModule, RequirementsAcknowledgementComponent],
  templateUrl: './allbids-dialog.component.html',
  styleUrl: './allbids-dialog.component.scss',
})
export class AllbidsDialogComponent {
  @Input() active: boolean = false;
  @Output() modalClosed = new EventEmitter<boolean>();
  @Input() data: any = '';
  @Input() documents: any = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() numberOfBids: number = 0;
  isSubmitting = false;
  user = getStoredUser();

  get hasAnySiteRequirements(): boolean {
    return projectHasSiteRequirements(this.data);
  }

  constructor(
    private proposalService: ProposalService,
    private projectService: ProjectService,
    private modalService: ModalService,
    private toastr: ToastrService
  ) {}

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  toggleOpenSubmittedAllBidsModal() {
    this.modalService.toggleOpenSubmittedAllBidsModal();
  }

  submit() {
    this.isSubmitting = true;
    this.proposalService
      .submitBid(this.data, this.user.id)
      .subscribe({
        next: (response: any) => {
          this.isSubmitting = false;
          let apiResponse: any = response;
          if (apiResponse.status === 'FAILURE') {
            if (apiResponse.message) {
              this.toastr.error(apiResponse.message);
            } else {
              this.toastr.error('An error occurred. Please try again.');
            }
          } else {
            const data = apiResponse.data;
            if (data) {
              this.closeDialog();
              this.toggleOpenSubmittedAllBidsModal();
              this.projectService.updateProjectDataSubjectWithProjectDetail(data);
            } else {
              this.toastr.error('An error occurred. Please try again.');
            }
          }
        },
        error: () => {
          this.isSubmitting = false;
          this.toastr.error('An error occurred. Please try again.');
        }
      });
  }
}
